import * as React from "react";
import { Loader } from "@fluentui/react-northstar";

export const LoaderExample = (props) => {
  return <Loader inline={true} label={props.label && props.label} />;
};
